import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { ObserverService } from '../../services/observer.service';
import { CartService } from '../../services/cart.service';
import { SupportedCurrencyService } from '../../services/supported-currency.service';
import { StorageService } from '../../services/storage.service';
import { RegisterService } from '../../services/register.service';

@Component({
    selector: 'app-cart-currency',
    templateUrl: './cart-currency.page.html',
    styleUrls: ['./cart-currency.page.scss'],
})
export class CartCurrencyPage implements OnInit {

    supported_currencies = null;
    cart_currency_id = null;
    register_id = null;
    register = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private observerService: ObserverService,
        private cartService: CartService,
        private supportedCurrencyService: SupportedCurrencyService,
        private storageService: StorageService,
        private registerService: RegisterService
    ) { }

    ngOnInit() {

        this.cartService.get().then((cart) => {
            this.cart_currency_id = cart['currency'].id;
        });

        this.supportedCurrencyService.getSupportedCurrencies().then((supported_currencies) => {

            if(supported_currencies) {

                this.supported_currencies = supported_currencies;

                this.supported_currencies.sort((a, b) => {
                    if (a['title'].toLowerCase() < b['title'].toLowerCase()) { return -1; }
                    if (a['title'].toLowerCase() > b['title'].toLowerCase()) { return 1; }
                    return 0;
                });

                this.storageService.get("register_id").then((register_id) => {

                    if(register_id) {

                        this.register_id = register_id;

                        this.registerService.getRegister(this.register_id).then((register) => {

                            if(register) {

                                this.register = register;

                                for(let i = 0; i < this.supported_currencies.length; i++) {

                                    // NOTE: default currency
                                    if(this.supported_currencies[i].id == this.register['location'].default_currency.id) {
                                        let register_location_default_currency = this.supported_currencies.splice(i, 1)[0];
                                        this.supported_currencies.unshift(register_location_default_currency);
                                        break;
                                    }

                                }
                            }
                        })
                        .catch(() => { });
                    }
                })
                .catch(() => { });



            }
        });

        this.observerService.subscribe('supported_currencies_changed|cart_currency_modal', supported_currencies => {
            this.supported_currencies = supported_currencies;
        });

        this.observerService.subscribe('supported_currency_added|cart_currency_modal', (supported_currency) => {
            if (supported_currency) {
                this.supported_currencies.push(supported_currency);
            }
        });

        this.observerService.subscribe('supported_currency_deleted|cart_currency_modal', (supported_currency) => {
            if (supported_currency) {
                for (let i = 0; i < this.supported_currencies.length; i++) {
                    if (this.supported_currencies[i].id === supported_currency["id"]) {
                        this.supported_currencies.splice(i, 1);
                        break;
                    }
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("supported_currencies_changed|cart_currency_modal");
        this.observerService.destroy("supported_currency_added|cart_currency_modal");
		this.observerService.destroy("supported_currency_deleted|cart_currency_modal");
    }

    close() {
        this.modalController.dismiss();
    }

    update() {
        for (let i = 0; i < this.supported_currencies.length; i++) {
            if (this.supported_currencies[i].id === this.cart_currency_id) {
                this.cartService.updateCurrency(this.supported_currencies[i]);
                break;
            }
        }
        this.modalController.dismiss();
    }

}
